import React, { Children, cloneElement, createElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Filter } from '../icons';
import Button from './Button';
import { Container } from '../types';
import { IconButton, MenuItem, MenuList, Popover } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

const { Grid } = Container;

const AddFilterButton = styled(Button)``;

const AddFilter = ({ buttonFullWidth, onChange, values, config }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterChoices, setFilterChoices] = useState([]);
  const [fieldsArr, setFieldsArr] = useState([]);

  useEffect(() => {
    const filterChoicesData = config.map(({ props }) => props.label);
    setFilterChoices(filterChoicesData);
  }, []);

  const handleOpenPopover = e => {
    e.stopPropagation();
    const { target } = e;
    setAnchorEl(target);
  };

  const handleDeleteField = (title, name, deleteItemIndex) => {
    setFilterChoices(prevState => [...prevState, title]);
    setFieldsArr(prevState => prevState.filter((_, index) => index !== deleteItemIndex));
    onChange(name, null);
  };

  const filtersChoices = filterChoices.map((title, index) => {
    const handleSelect = () => {
      const field = config.find(({ props: { label } }) => label === title);

      const newField = createElement(
        field.component,
        {
          id: `add-filter-${title}`,
          onChange: (e, value) => {
            if (value !== undefined) {
              onChange(field.props.name, +value);
            } else {
              onChange(field.props.name, e.target.value);
            }
          },
          allowEmpty: false,
          fullWidth: true,
          ...field.props
        },
        null
      );

      setFieldsArr(prevState => [...prevState, newField]);

      setFilterChoices(prevState => prevState.filter(choice => choice !== title));
      setAnchorEl(null);
    };
    return (
      <MenuItem key={`menu-item-${index}`} onClick={handleSelect}>
        {title}
      </MenuItem>
    );
  });

  return (
    <>
      {fieldsArr.map((Component, index) => {
        const { getValue, choices, options, label, name, grid } = Component.props;
        return (
          <Grid {...grid} item alignItems={'center'} key={`filter-fields-${index}`}>
            <IconButton size="small" onClick={() => handleDeleteField(label, name, index)} mr={2}>
              <CloseIcon />
            </IconButton>
            {cloneElement(Component, {
              checked: !!values?.[name] || false,
              value: getValue ? getValue(options || choices, values?.[name]) : values?.[name]
            })}
          </Grid>
        );
      })}

      {!!filtersChoices.length && (
        <Grid xs={2} item>
          <AddFilterButton
            fullwidth={buttonFullWidth}
            aria-describedby={'add-filter-popper'}
            onClick={handleOpenPopover}
          >
            <Filter mr={1} />
            Add Filter
          </AddFilterButton>
        </Grid>
      )}

      <Popover
        id={'add-filter-popper'}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        PaperProps={{
          style: {
            minWidth: '135px'
          }
        }}
      >
        <MenuList id="simple-menu-filter">{filtersChoices}</MenuList>
      </Popover>
    </>
  );
};

export default AddFilter;
